import { SpintrTypes } from "src/typings";

function isAdministrator(appState: Spintr.AppState): boolean {
    return appState.profile.active.roles.includes("administrators");
}

type Privilege = {
    value: boolean;
    privilegeId: number;
}

export function isHubAdministrator(appState: Spintr.AppState): boolean {
    if (isAdministrator(appState)) {
        return true;
    }

    const privileges = appState.privileges.data || [];

    return privileges.some(
        (p: Privilege) => p.value &&
            p.privilegeId === SpintrTypes.Privilege.IsQualityHubAdministrator);
}

